export default "__VITE_ASSET__CkcSW4RF__"